/**
 * @file Xoe experts API — list available AI expert personas.
 * @module api/xoe/XoeExpertsApi
 */

import { XoeExpert } from '../../types/xoe/XoeTypes';
import { ENV } from '../../config/runtimeEnv';
import { http } from '../../lib/http/client';


/**
 * List available Xoe expert personas for the clinic.
 */
export const listXoeExperts = async (): Promise<XoeExpert[]> => {
	const response = await http.get(
		`${ENV.VITE_XOE_AGENT_SERVER}/practitioner/xoe/experts`,
	);
	// Backend wraps the list: { data: [...] }
	return response.data.data;
};
